import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Form, Modal, Spinner, FormLabel } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { createBranchOffice } from 'redux/branchOfficeSlice';
import { getRealEstateData } from '../../../../../redux/realEstateSlice';

const ModalCreateBO = ({ show, handleClose, realEstateId }) => {
  // * States
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');

  // * Methods
  const CreateBranchOffice = async () => {
    setLoading(true);
    const response = await dispatch(createBranchOffice(name, realEstateId));
    if (response?.status === 201) {
      await dispatch(getRealEstateData(realEstateId));
      handleClose();
    }

    setLoading(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Crear Nueva Sucursal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <FormLabel>
            Nombre de sucursal&nbsp;
            <Form.Text className="text-muted">
              (Debe tener al menos 5 caracteres)
            </Form.Text>
          </FormLabel>
          <Form.Control
            type="text"
            label="Nombre de sucursal"
            size="md"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Ingrese el nombre de la sucursal"
          />
          <Form.Text className="text-muted">
            * Recuerde completar el resto de los campos al crear la nueva
            sucursal
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <div className="d-flex justify-content-end">
          <Button
            variant="success"
            onClick={!loading && name !== '' ? CreateBranchOffice : () => {}}
            disabled={loading || name === '' || name.length < 5}
            className="d-flex justify-content-center align-items-center"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Crear'
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ModalCreateBO.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  realEstateId: PropTypes.string
};

export default ModalCreateBO;
